<div class="forgot-password">
  <div class="div">
    <div class="card">
      <div class="frame" *ngIf="!isSuccess && !hasError">
        <div class="frame-2">
          <div class="frame-3">
            <div class="text-wrapper-3">New Password</div>
            <p class="no-worries-just-en">
              Please create a new password that you don’t use on any other site.
              Password must be at least 8 characters long with at least 1 number
              or symbol.
            </p>
          </div>
          <form
            [formGroup]="formGroup"
            (ngSubmit)="updatePassword(this.token!)"
            class="password-wrapper"
          >
            <input
              type="password"
              id="password"
              formControlName="passwordFormControl"
              class="email-address-wrapper"
              placeholder="Create new password"
              (input)="onInputChange()"
            />
            <input
              type="password"
              id="confirmPassword"
              formControlName="confirmPasswordFormControl"
              class="email-address-wrapper"
              placeholder="Confirm new password"
              (input)="onInputChange()"
            />
            <div
              *ngIf="passwordValidationError && isSubmitted"
              class="error-message"
            >
              {{ passwordValidationError }}
            </div>
            <button type="submit" class="button" [disabled]="isReset">
              Save Password
            </button>
          </form>
        </div>
      </div>
      <reset-success *ngIf="isSuccess" />
      <reset-failed *ngIf="hasError" (childEvent)="updateIsClicked($event)" />
    </div>
    <img class="image" alt="Image" src="../../../assets/image.svg" />
  </div>
</div>
